import React, { useContext } from 'react';

import { SearchApi } from '../apis';
import { api } from '../api';

const SearchApiContext = React.createContext(new SearchApi(api));

export const SearchApiProvider = SearchApiContext.Provider;
export const useSearchApi = (): SearchApi => useContext(SearchApiContext);
